<template>
  <div class="bg-static-default-hi body-1-bold p-4 text-center">
    {{ i18n(translations.yearOnYear) }}
  </div>
  <RevTable :collection="yearOnYearReport" :columns>
    <template #body-percentage="{ item }">
      <span :class="{ 'body-1-bold': item.metric === 'TOTAL' }">
        <Trend :has-arrow="true" :value="item.percentage" />
      </span>
    </template>
    <template #body-amount="{ item }">
      <span :class="{ 'body-1-bold': item.metric === 'TOTAL' }">
        {{ item.amount }}
      </span>
    </template>
  </RevTable>
</template>

<script lang="ts" setup>
import type { FinancialYearOnYearReport } from '@backmarket/http-api/src/api-specs-seller-backoffice/merchants/financial-report.types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTable } from '@ds/components/Table'
import type { Column } from '@ds/components/Table/Table.constant'

import Trend from '@/components/Trend/Trend.vue'

import translations from './YearOnYearTable.translations'

defineProps<{
  yearOnYearReport: FinancialYearOnYearReport[]
}>()

const i18n = useI18n()

const columns: Column[] = [
  {
    key: 'amount',
    label: i18n(translations.amount),
    align: 'end' as const,
    headerClassNames: 'text-right',
  },
  {
    key: 'percentage',
    label: i18n(translations.percentage),
    align: 'end' as const,
    headerClassNames: 'text-right',
  },
]
</script>
